(() => {
  const key = 'nolayer-cart-reserved-until';
  const duration = 15 * 60 * 1000;
  function getEnd() {
    const now = Date.now();
    let end = Number(sessionStorage.getItem(key));
    if (!end || end <= now) {
      end = now + duration;
      sessionStorage.setItem(key, String(end));
    }
    return end;
  }
  function update() {
    const output = document.querySelector('[data-nl-cart-time]');
    if (!output) return;
    const remaining = Math.max(0, getEnd() - Date.now());
    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    output.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
  update();
  window.setInterval(update, 1000);
})();
